module.exports = __webpack_public_path__ + "static/lk.d5cf9401.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/lk.svg
// module id = 2168
// module chunks = 79611799117203